<template>
    <div style="height: 100%">
        <div style="display: flex;justify-content: space-between;width: 95%;margin: 0 auto;">
            <div style="margin: 10px; display: flex; padding-left: 20px">
                <el-date-picker v-model="formDatas.dateMonth" type="month" value-format="yyyy-MM" placeholder="选择年月"
                    style="width:150px;" size="small" @change="getList" clearable>
                </el-date-picker>
                <el-button type="info" size="small" icon="el-icon-search" @click="getList2"
                    style="margin-left: 10px">刷新</el-button>
                <el-button type="primary" size="small" style="margin-left: 10px" @click="openRowUser">行数据</el-button>
                <el-button type="primary" size="small" style="margin-left: 10px" @click="openColUser">列数据</el-button>
                <el-button type="primary" size="small" style="margin-left: 10px" @click="out">导出</el-button>
                <div style="font-size: 16px;font-weight: 500;color: #409EFF;margin-left: 20px;line-height: 30px;"
                    v-if="timeData && timeData.createtime">
                    纷享销客同步时间:{{ timeData.createtime }}
                </div>
            </div>
            <div style="margin: 10px; display: flex; padding-right: 20px">
                <el-dropdown trigger="click" @command="handleCommand" style="font-size: 19px;" v-if="userStr">
                    <span class="el-dropdown-link">
                        {{ userStr.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">退出登录</el-dropdown-item>
                        <el-dropdown-item command="b">修改密码</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" size="small" style="margin-left: 10px" @click="openUser"
                    v-if="userStr && userStr.fduEdit == 2">编辑用户权限</el-button>
            </div>
        </div>
        <div style="width: 100%;margin: 20px auto;">
            <ve-table ref="vetableMain" :columns="columnsHead" :table-data="tableData" :max-height="800"
                :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                row-key-field-name="fduId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                :virtual-scroll-option="virtualScrollOption" />
            <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <el-dialog title="详情" :visible.sync="isDetail" width="60%" top="8vh" :close-on-click-modal="false">
            <el-card style="width: 95%;margin: 15px auto;white-space: pre-wrap"
                v-if="detailStr[`fdisDate${this.date}`]">

                {{ detailStr[`fdisDate${this.date}`] }}
            </el-card>
            <!-- <div style="width: 95%;margin: 15px auto;display: flex;flex-direction: row-reverse;"
                v-if="detailStr.fduId && userStr.fduEdit == 2">
                <el-button type="primary" size="small" style="margin-left: 20px" @click="beXcb">内勤专用标记</el-button>
            </div> -->
            <el-card style="width: 95%;margin: 15px auto;" v-if="detailStr.fduId && userStr.fduEdit == 2">
                <p style="font-size: 20px;margin: 10px 0;">内勤专用标记</p>
                <el-input v-model="fiNqName" type="textarea" style="width: 80%" placeholder="请输入"></el-input>
                <el-button type="danger" size="small" style="margin-left: 20px" @click="restXcb">重置</el-button>
            </el-card>
            <span slot="footer" class="dialog-footer" v-if="isEdit">
                <el-button @click="CloseXcb">取 消</el-button>
                <el-button type="primary" @click="sureXcb">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="钉钉用户" :visible.sync="isUserAll" width="70%" top="8vh" :before-close="closeUser">
            <div style="width: 95%;margin: 10px auto;display: flex;">
                <el-input v-model="formDatas2.name" style="width: 140px;" size="small" placeholder="请输入用户名称"
                    clearable></el-input>
                <el-cascader v-model="formDatas2.deptId" :props="props" :options="getFxxkDingDepartmentList_data"
                    clearable size="small" placeholder="请选择部门" @change="cascaderChange"></el-cascader>
                <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                    style="margin-left: 10px">搜索</el-button>
            </div>
            <div style="width: 100%">
                <ve-table ref="vetableUser" v-if="tableDataUser" :columns="columnsUser" :table-data="tableDataUser"
                    :max-height="500" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" row-key-field-name="fduId" style="width: 100%" />
                <div v-show="tableDataUser.length == 0" class="empty-data">暂无数据</div>
            </div>
        </el-dialog>
        <div v-if="isLogin"
            style="width: 100%;height: 100%;position: fixed;top: 0;left: 0;background-color: rgba(4, 0, 2, 0.5);display: flex;align-items: center;justify-content: center;">
            <div
                style="width: 30%;height: 300px;background-color: white;border-radius: 20px;display: flex;flex-direction: column;justify-content: center;">
                <div style="width: 90%;margin: 1% auto;font-size: 20px;text-align: center;height: 30px;">
                    登录
                </div>
                <div style="width: 70%;margin: 10px auto;">
                    <el-form ref="form" :model="form" label-position="left" @submit.native.prevent>
                        <el-form-item label="">
                            <el-input style="" prefix-icon="el-icon-user
                    " v-model="form.name" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <div style="margin-top: 5%;">
                            <el-form-item label="">
                                <el-input style="" prefix-icon="el-icon-lock
                      " show-password v-model="form.fduPw" placeholder="请输入密码"></el-input>
                            </el-form-item>
                        </div>

                        <el-button type="primary" plain style="width: 100%;" @click="login">
                            立即登录
                        </el-button>
                    </el-form>
                </div>

            </div>
        </div>
        <el-dialog title="编辑" :visible.sync="isUserEdit" width="50%" top="8vh" :before-close="handleClose">
            <el-form ref="formRef2" :model="form2" label-position="left" style="height:40vh" label-width="150px"
                size="small">
                <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 20px 50px 15px;overflow-x: hidden;">
                    <el-form-item label="是否登录" prop="fduLogin">
                        <el-radio-group v-model="form2.fduLogin">
                            <el-radio :label="1">否</el-radio>
                            <el-radio :label="2">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否可以编辑" prop="fduEdit">
                        <el-radio-group v-model="form2.fduEdit">
                            <el-radio :label="1">否</el-radio>
                            <el-radio :label="2">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="SureBtn">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改密码" :visible.sync="updataPw" width="25%" center>
            <p>新密码</p>
            <el-input v-model="fduPw" autocomplete="off"></el-input>

            <span slot="footer" class="dialog-footer">
                <el-button @click="updataPw = false; fduPw = ''">取 消</el-button>
                <el-button type="primary" @click="updataPwclick">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="行数据" :visible.sync="isRowUser" width="70%" top="8vh" :before-close="closeRowUser"
            :close-on-click-modal="false">
            <div style="width: 95%;margin: 10px auto;display: flex;">
                <el-input v-model="formDatas2.name" style="width: 140px;" size="small" placeholder="请输入用户名称"
                    clearable></el-input>
                <el-cascader v-model="formDatas2.deptId" :props="props" :options="getFxxkDingDepartmentList_data"
                    clearable size="small" placeholder="请选择部门" @change="cascaderChange2"></el-cascader>
                <el-button type="info" size="small" icon="el-icon-search" @click="getRowUser"
                    style="margin-left: 10px">搜索</el-button>
            </div>
            <div style="width: 100%">
                <ve-table ref="vetable" v-if="rowUserTable" :columns="columnRow" :table-data="rowUserTable"
                    :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fduarId"
                    :cellSelectionOption="cellSelectionOption2" style="width: 100%" :editOption="editOption" />
                <div v-show="rowUserTable.length == 0" class="empty-data">暂无数据</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeRowUser">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog title="列数据" :visible.sync="isColUser" width="70%" top="8vh" :before-close="closeColUser"
            :close-on-click-modal="false">
            <div style="width: 100%">
                <ve-table ref="vetable" v-if="ColUserTable" :columns="columnCol" :table-data="ColUserTable"
                    :max-height="600" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fduacId"
                    :cellSelectionOption="cellSelectionOption2" style="width: 100%" :editOption="editOption2" />
                <div v-show="ColUserTable.length == 0" class="empty-data">暂无数据</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeColUser">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import config from "../api/env.js";
import { mapState, mapMutations, mapAction } from 'vuex'
import {
    getFxxkDingItineraryStatisticHeaderSelected,
    getFxxkDingItineraryStatistic, updateFxxkDingItinerarySub, updateFxxkDingItinerarySubDataSignReset, getFxxkDingItinerarySubUpdateByDate,
    doFxxkDingUserLogin, getFxxkDingUserList, getFxxkDingDepartmentList, updateFxxkDingUserAuth, updateFxxkDingUserPw, getFxxkDingUserAuth,
    getFxxkDingUserAuthRowList, updateFxxkDingUserAuthRow, getFxxkDingUserAuthRowDetails, getFxxkDingUserAuthColList, updateFxxkDingUserAuthCol,
} from "../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            formRow: {},
            columnCol: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "fduacDateMonth",
                    key: "fduacDateMonth",
                    title: "年月",
                    align: "center",
                },
                {
                    field: "fduacDateDay",
                    key: "fduacDateDay",
                    title: "天",
                    align: "center",
                },
                {
                    field: "fduacShow",
                    key: "fduacShow",
                    title: "是否显示",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="height:50px;line-height:50px;">
                                <el-radio-group value={row.fduacShow} on-input={(e) => this.colDataChange(e, rowIndex, row)}>
                                    <el-radio label={1}>显示</el-radio>
                                    <el-radio label={2}>隐藏</el-radio>
                                </el-radio-group>
                            </div>

                        )
                    }
                },
            ],
            ColUserTable: [],
            isColUser: false,
            theColData: '',//编辑列成功后返回的数据
            theRowData: '',//编辑行成功后返回的数据
            radio: [],
            Colradio: [],
            columnRow: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: "用户名称",
                    align: "center",
                },
                {
                    field: "deptName",
                    key: "deptName",
                    title: "部门",
                    align: "center",
                },
                {
                    field: "fduarShow",
                    key: "fduarShow",
                    title: "是否显示",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="height:50px;line-height:50px;">
                                <el-radio-group value={row.fduarShow} on-input={(e) => this.rowDataChange(e, rowIndex, row)}>
                                    <el-radio label={1}>显示</el-radio>
                                    <el-radio label={2}>隐藏</el-radio>
                                </el-radio-group>
                            </div>

                        )
                    }
                },
                {
                    field: "fduarOrder",
                    key: "fduarOrder",
                    title: "排序",
                    align: "center",
                    edit: true,
                },
            ],
            isRowUser: false,
            rowUserTable: [],
            sourceData: [],
            searchValue: [],
            searchValue2: [],
            fduPw: '',
            updataPw: false,
            form2: {

            },
            isUserEdit: false,
            tableDataUser: [],
            columnsUser: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: "用户名称",
                    align: "center",
                },
                {
                    field: "deptName",
                    key: "deptName",
                    title: "部门",
                    align: "center",
                },
                {
                    field: "fduLogin",
                    key: "fduLogin",
                    title: "是否可以登录",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fduLogin == 1 ? <el-tag type="danger" style="margin-left:10px">否</el-tag> : <el-tag type="success" style="margin-left:10px">是</el-tag>
                                }
                            </span>
                        )
                    }
                },
                {
                    field: "fduEdit",
                    key: "fduEdit",
                    title: "是否可以编辑",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fduEdit == 1 ? <el-tag type="danger" style="margin-left:10px">否</el-tag> : <el-tag type="success" style="margin-left:10px">是</el-tag>
                                }
                            </span>
                        )
                    }
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑权限
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            props: {
                value: 'deptId',
                label: 'name',
                children: 'fxxkDingDepartmentChildList',
            },
            getFxxkDingDepartmentList_data: [],
            departmentArr: [],
            isUserAll: false,

            formDatas2: {},
            userStr: '',
            form: {
                name: '',
                fduPw: '',
            },
            isLogin: true,
            timeData: '',//更新时间
            rowIndex: '',
            fiNqName: '',
            date: '',
            isDetail: false,
            detailStr: '',
            isEdit: false,
            formDatas: {
                dateMonth: '',
                userBelongs: '',
                deptNames: '',
                names: '',
                userDateEntrys: '',
                selectFilters: [],
            },
            virtualScrollOption: {
                // 是否开启
                enable: false,
            },
            tableHead: [],
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            editOption2: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange2(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange2(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            cellSelectionOption2: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (column.title == '六' || column.title == '日') {
                        return "table-header-cell-class2";
                    }
                    if (rowIndex === 0 || rowIndex === 1) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 820,
            columnsHead: [

            ], //表格的列
            tableData: [],

        };
    },
    activated() {
    },
    watch: {
    },

    created() {
        // this.getList()
        if (window.localStorage.getItem('fduId')) {
            this.isLogin = false;
            getFxxkDingUserAuth().then(res => {
                this.userStr = res.data
            })
            this.getList()
        }
    },
    mounted() {

    },
    methods: {
        getList2() {
            this.formDatas = {
                dateMonth: '',
                userBelongs: '',
                deptNames: '',
                names: '',
                userDateEntrys: '',
                selectFilters: []
            }
            this.searchValue = [];
            this.searchValue2 = {}
            this.getList()
        },
        getRowUser() {
            this.openLoading()
            getFxxkDingUserAuthRowList(this.formDatas2).then(res => {
                this.rowUserTable = res.data;
                this.loadings.close();
            })
        },
        getUserDetail(row, rowIndex) {
            getFxxkDingUserAuthRowDetails({ fduId: row.fduId }).then(res => {
                this.rowUserTable.push(res.data);
                this.isRowUser = true;
            })

        },
        colDataChange(e, index, row) {
            console.log(e);
            row.fduacShow = e
            this.Colradio[index] = e;
            updateFxxkDingUserAuthCol({ fduacId: row.fduacId, fduacShow: e }).then(res => {
                this.theColData = res.data;
            })
        },
        rowDataChange(e, index, row) {
            console.log(e);
            row.fduarShow = e
            this.radio[index] = e;
            updateFxxkDingUserAuthRow({ fduarId: row.fduarId, fduarShow: e }).then(res => {
                this.theRowData = res.data;
            })
        },
        closeRowUser() {
            if (this.rowUserTable.length > 1) {
                this.getList();
                this.isRowUser = false;
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.theRowData.fduarFduId == item.fduId && this.theRowData.fduarShow == 2) {
                        this.tableData.splice(index, 1)
                    } else if (this.theRowData.fduarFduId == item.fduId && this.theRowData.fduarShow == 1) {
                        let itemToUpdate = this.tableData.find(items => items.fduId === this.theRowData.fduarFduId);
                        if (itemToUpdate) {
                            itemToUpdate.fduarOrder = this.theRowData.fduarOrder;
                        }
                        // 根据order重新排序数组
                        this.tableData.sort((a, b) => a.fduarOrder - b.fduarOrder);
                    }
                })
                this.isRowUser = false;
                this.sourceData.forEach((item, index) => {
                    if (this.theRowData.fduarFduId == item.fduId && this.theRowData.fduarShow == 2) {
                        this.sourceData.splice(index, 1)
                    } else if (this.theRowData.fduarFduId == item.fduId && this.theRowData.fduarShow == 1) {
                        console.log('单条');
                        let itemToUpdate = this.sourceData.find(items => items.fduId === this.theRowData.fduarFduId);
                        console.log(itemToUpdate);
                        if (itemToUpdate) {
                            itemToUpdate.fduarOrder = this.theRowData.fduarOrder;
                        }
                        // 根据order重新排序数组
                        this.sourceData.sort((a, b) => a.fduarOrder - b.fduarOrder);
                    }
                })
            }
            this.rowUserTable = []

        },
        closeColUser() {
            this.getList();
            this.isColUser = false;
        },
        // 列数据
        openColUser() {
            this.openLoading()
            getFxxkDingUserAuthColList(this.formDatas).then(res => {
                this.ColUserTable = res.data;
                this.isColUser = true;
                this.loadings.close();
            })
        },
        // 行数据
        openRowUser() {
            this.openLoading()
            getFxxkDingUserAuthRowList().then(res => {
                getFxxkDingDepartmentList().then(res => {
                    this.getFxxkDingDepartmentList_data = res.data
                })
                this.rowUserTable = res.data;
                this.isRowUser = true;
                this.loadings.close();
            })
        },
        OutLogin() {
            localStorage.clear();
            location.reload();
            this.isLogin = true
        },
        handleCommand(command) {
            if (command == "a") {
                this.OutLogin()
            } else {
                this.updataPw = true;
            }
        },
        updataPwclick() {
            if (this.fduPw == '') {
                this.$message({
                    type: 'warning',
                    message: '请输入密码!'
                })
            } else {
                updateFxxkDingUserPw({ fduPw: this.fduPw, fduId: this.userStr.fduId }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    })
                    this.updataPw = false;
                    this.suPw = '';

                })
            }
        },
        // 关闭弹框
        handleClose() {
            this.isUserEdit = false
            this.$refs['formRef2'].resetFields();
        },
        SureBtn() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.form2))
                    updateFxxkDingUserAuth(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.handleClose()
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.form2 = data;
            this.isUserEdit = true
        },
        openUser() {
            this.partserch();
            this.isUserAll = true;
        },
        closeUser() {
            this.isUserAll = false;
        },
        cascaderChange(e) {
            console.log(e);
            this.formDatas2.deptId = e[e.length - 1];
            this.partserch()
        },
        cascaderChange2(e) {
            console.log(e);
            this.formDatas2.deptId = e[e.length - 1];
            this.getRowUser()
        },
        ...mapMutations(['changeuser']),
        login() {
            if (this.form.name == '' || this.form.fduPw == '') {
                this.$message({
                    showClose: true,
                    message: '请输入用户名和密码',
                    type: 'danger'
                });
            }
            doFxxkDingUserLogin(this.form).then(res => {
                if (res.status == 200) {
                    console.log('登录成功了', res.data.fduId)
                    this.$notify({
                        title: '成功',
                        message: '登录成功',
                        type: 'success'
                    });
                    this.changeuser({ userid: res.data })
                    this.isLogin = false;
                    this.userStr = res.data
                    this.getList()
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg
                    });
                }

            })
        },
        out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading();
            var that = this;
            axios({
                method: "post",
                url: config.baseURL + "/fxxk-ding-itinerary/exportFxxkDingItineraryStatistic",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'fduid': window.localStorage.getItem('fduId'),
                },
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel",
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "行程表.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success",
                    });
                }
            });
        },
        restXcb() {
            this.$confirm("此操作将重置该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.openLoading();
                    updateFxxkDingItinerarySubDataSignReset({ fdisId: this.detailStr[`fdisId${this.date}`] }).then(res => {
                        if (this.date == res.data.fdisDate) {
                            this.detailStr[`fdisDate${this.date}`] = res.data.fiNqName;
                            this.detailStr[`fdisColor${this.date}`] = res.data.fiNqCourseSignColor;
                            this.$set(this.tableData, this.rowIndex, this.detailStr);
                        }
                        this.$message({
                            type: "success",
                            message: "重置成功!",
                        });
                        this.CloseXcb();
                        this.loadings.close();
                    })
                })
                .catch(() => { })

        },
        beXcb() {
            this.isEdit = true
        },
        CloseXcb() {
            this.detailStr = '';
            this.date = ''
            this.fiNqName = ''
            this.isDetail = false;
            this.isEdit = false;
        },
        sureXcb() {
            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.openLoading();
                    updateFxxkDingItinerarySub({ fdisId: this.detailStr[`fdisId${this.date}`], fiNqName: this.fiNqName }).then(res => {
                        if (this.date == res.data.fdisDate) {
                            this.detailStr[`fdisDate${this.date}`] = res.data.fiNqNameShow;
                            this.detailStr[`fiNqName${this.date}`] = res.data.fiNqName;
                            this.detailStr[`fdisColor${this.date}`] = res.data.fiNqCourseSignColor;
                            this.$set(this.tableData, this.rowIndex, this.detailStr);
                        }
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                        this.CloseXcb();
                        this.loadings.close();
                    })
                })
                .catch(() => { })
        },
        getDetail(row, date, index) {
            this.openLoading();
            this.detailStr = row;
            this.date = date;
            this.rowIndex = index
            this.isDetail = true;
            this.isEdit = true;
            this.fiNqName = this.detailStr[`fiNqName${this.date}`] ? JSON.parse(this.detailStr[`fiNqName${this.date}`])[0] : '';
            this.loadings.close();
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fduarId = row.fduarId
                    console.log(jsonObj);
                    updateFxxkDingUserAuthRow(jsonObj).then(res => {
                        this.theRowData = res.data;
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        // 修改单元格2
        async beforeCellValChange2(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fduarId = row.fduarId
                    console.log(jsonObj);
                    updateFxxkDingUserAuthRow(jsonObj).then(res => {
                        this.theRowData = res.data;
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkDingItineraryStatistic(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        //搜索
        search(date) {
            const foundObject = this.searchValue2.find(obj => obj.fdisDate === date);
            if (foundObject) {
                // 如果存在，更新 val 值
                foundObject.searchValue = this.searchValue[date];
                console.log(this.searchValue2);
            } else {
                // 如果不存在，创建一个新对象并 push 到数组中
                this.searchValue2.push({ fdisDate: date, searchValue: this.searchValue[date] });
                console.log(this.searchValue2);
            }
            this.getList();
        },
        //搜索
        search2(key, index) {
            const searchValue = this.searchValue2[index];
            if (searchValue == '' || !searchValue) {
                return this.tableData = this.sourceData, this.searchValue2 = [], this.loadings.close();

            }
            this.tableData = this.sourceData.filter(
                (x) => {
                    if (x[key]) {
                        return !searchValue.length ||
                            x[key].includes(searchValue)
                    }

                }

            );
            this.loadings.close();
        },
        searchCancel(closeFn) {
            closeFn();
        },

        // search cancel
        searchConfirm(closeFn, date) {
            this.openLoading()
            this.search(date);
            closeFn();
        },
        searchConfirm2(closeFn, key, index) {
            this.openLoading()
            this.search2(key, index);
            closeFn();
        },
        partserch() {
            getFxxkDingUserList(this.formDatas2).then((res) => {
                this.tableDataUser = res.data;
            });
            getFxxkDingDepartmentList().then(res => {
                this.getFxxkDingDepartmentList_data = res.data
            })
        },
        async ob(i, item) {
            console.log(i, item);
            var filterarr = [];
            const data = await getFxxkDingItineraryStatisticHeaderSelected({ selectedType: item });
            if (this.formDatas[item + "s"]) {
                console.log(this.formDatas[item + "s"]);
                const arr = this.formDatas[item + "s"].split(",");
                arr.forEach((datas, i) => {
                    data.data.forEach((ite, index) => {
                        if (datas == ite.name) {
                            const s = {
                                label: ite.name + `[${ite.num}]`,
                                selected: true,
                                value: index,
                            };
                            filterarr.push(s);
                        } else {
                            const s = {
                                label: ite.name + `[${ite.num}]`,
                                selected: false,
                                value: index,
                            };
                            filterarr.push(s);
                        }
                    });
                });

                let map = new Map();
                let filterList = [];
                for (let itt of filterarr) {
                    map.set(itt.value, itt);
                }

                filterList = [...map.values()];
                filterarr = filterList;
            } else {
                data.data.forEach((ite, index) => {
                    const s = {
                        label: ite.name + `[${ite.num}]`,
                        selected: false,
                        value: index,
                    };
                    filterarr.push(s);
                });
            }
            console.log("初始化");
            this.$nextTick(() => {
                this.$set(this.columnsHead[i].filter, "filterList", filterarr);
                this.$refs["vetableMain"].colgroups[i].filter.filterList = filterarr;
            });
        },
        searchByNameFieldCopy(labels, id) {
            if (labels == []) {
                this.formDatas[id] = "";

                this.getList();
                return;
            }
            const arr = labels;
            labels.forEach((item, index) => {
                const a = item.indexOf("[");
                arr[index] = item.substring(0, a);
            });
            this.formDatas[id] = arr.toString();

            this.getList();
            // this.bulkData = this.bulkDataCopy.filter(
            //     (x) => labels.length === 0 || labels.includes(x[id]),
            // );
        },
        async getList() {
            this.columns = [

            ];
            this.tableData = [];
            this.sourceData = [];
            const arr = [
                {
                    field: "userBelong",
                    key: "userBelong",
                    title: "归属",
                    width: 70,
                    fixed: 'left',
                    align: "center",
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                    renderHeaderCell: ({ column }, h) => {
                        return (
                            <span >
                                <span style={{ color: this.formDatas.userBelongs ? 'red' : 'black' }} >归属</span>
                            </span>
                        );
                    },
                    filter: {
                        filterList: [],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, "userBelongs");
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], "userBelongs");
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(0, "userBelong");
                                console.log(nextVisible);
                            }
                        },
                    },
                },
                {
                    field: "deptName",
                    key: "deptName",
                    title: "部门",
                    width: 80,
                    fixed: 'left',
                    align: "center",
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                    renderHeaderCell: ({ column }, h) => {
                        return (
                            <span >
                                <span style={{ color: this.formDatas.deptNames ? 'red' : 'black' }} >部门</span>
                            </span>
                        );
                    },
                    filter: {
                        filterList: [],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, "deptNames");
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], "deptNames");
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(1, "deptName");
                                console.log(nextVisible);
                            }
                        },
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: "姓名",
                    width: 80,
                    fixed: 'left',
                    align: "center",
                    ellipsis: {
                        showTitle: false,
                        lineClamp: 1,
                    },
                    renderHeaderCell: ({ column }, h) => {
                        return (
                            <span >
                                <span style={{ color: this.formDatas.names ? 'red' : 'black' }} >姓名</span>
                            </span>
                        );
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div onDblclick={() => this.getUserDetail(row, rowIndex)} style={{ width: '100%', minHeight: '22px', }} >
                                {row.name}
                            </div>
                        );
                    },
                    filter: {
                        filterList: [],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, "names");
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], "names");
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(2, "name");
                                console.log(nextVisible);
                            }
                        },
                    },
                },
                {
                    field: "userDateEntry",
                    key: "userDateEntry",
                    title: "入职时间",
                    width: 95,
                    fixed: 'left',
                    align: "center",
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                    renderHeaderCell: ({ column }, h) => {
                        return (
                            <span >
                                <span style={{ color: this.formDatas.userDateEntrys ? 'red' : 'black' }} >入职时间</span>
                            </span>
                        );
                    },
                    filter: {
                        filterList: [],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, "userDateEntrys");
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], "userDateEntrys");
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(3, "userDateEntry");
                                console.log(nextVisible);
                            }
                        },
                    },
                },
            ];
            this.openLoading();
            getFxxkDingItinerarySubUpdateByDate(this.formDatas).then(res => {
                this.timeData = res.data
            })
            this.formDatas.selectFilters = this.searchValue2
            const newForm = JSON.parse(JSON.stringify(this.formDatas))
            newForm.selectFilters = newForm.selectFilters && newForm.selectFilters.length > 0 ? JSON.stringify(newForm.selectFilters) : ''
            getFxxkDingItineraryStatistic(newForm).then(res => {
                res.item.forEach((item, index) => {
                    let s = {
                        title: item.fdisWeek,
                        renderHeaderCell: ({ column }, h) => {
                            return (
                                <span>
                                    {item.fdisWeek == '六' || item.fdisWeek == '日' ? (
                                        <div style="width:100%;height:100%;background:#FF99CC;color:#fff;">
                                            {item.fdisWeek}
                                        </div>
                                    ) : (
                                        <span>{item.fdisWeek}</span>
                                    )}
                                </span>
                            );
                        },
                        children: [
                            {
                                field: 'fdisDate' + item.fdisDate,
                                key: index + '',
                                title: item.fdisDateShow,
                                align: 'center',
                                width: 60,
                                renderHeaderCell: ({ column }, h) => {
                                    return (
                                        <span >
                                            <span style={{ color: this.searchValue[item.fdisDate] ? 'red' : 'black' }} >{item.fdisDateShow}</span>
                                        </span>
                                    );
                                },
                                renderBodyCell: ({ row, column, rowIndex }, h) => {
                                    return (
                                        <div>
                                            {
                                                row[`fdisDate${item.fdisDate}`] ? <el-popover placement="top-start" width="500" trigger="focus" content={row[`fdisDate${item.fdisDate}`]} style="white-space: pre-wrap" >
                                                    <div slot="reference" onDblclick={() => this.getDetail(row, item.fdisDate, rowIndex)} style={{ width: '100%', minHeight: '22px', background: row[`fdisColor${item.fdisDate}`] }} >
                                                        {row[`fdisDate${item.fdisDate}`]}
                                                    </div>
                                                </el-popover> : <div  onDblclick={() => this.getDetail(row, item.fdisDate, rowIndex)} style={{ width: '100%', minHeight: '22px', background: row[`fdisColor${item.fdisDate}`] }} >
                                                    {row[`fdisDate${item.fdisDate}`]}
                                                </div>
                                            }
                                        </div>



                                    );
                                },
                                ellipsis: {
                                    showTitle: false,
                                    lineClamp: 1,
                                },
                                filterCustom: {
                                    defaultVisible: false,
                                    render: ({ showFn, closeFn }, h) => {
                                        return (
                                            <div class="custom-name-filter">
                                                <input
                                                    value={this.searchValue[item.fdisDate]}
                                                    on-input={(e) => (this.searchValue[item.fdisDate] = e.target.value)}
                                                    placeholder="请输入"
                                                />
                                                <div class="custom-name-filter-operation">
                                                    <span
                                                        class="name-filter-cancel"
                                                        on-click={() => this.searchCancel(closeFn, item.fdisDate)}
                                                    >
                                                        取消
                                                    </span>
                                                    <span
                                                        class="name-filter-confirm"
                                                        on-click={() => this.searchConfirm(closeFn, item.fdisDate)}
                                                    >
                                                        查询
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    },
                                },
                            }
                        ],
                    }
                    arr.push(s)
                })
                this.columnsHead = arr;
                res.data.forEach((item, idnex) => {
                    let data = {
                        deptName: item.deptName,
                        fduId: item.fduId,
                        name: item.name,
                        userDateEntry: item.userDateEntry,
                        userBelong: item.userBelong,
                        fduarOrder: item.fduarOrder,
                        fduarShow: item.fduarShow
                    }
                    item.fxxkDingItinerarySubList.forEach((val, valIndex) => {
                        data[`fdisDate${val.fdisDate}`] = val.fiNqNameShow;
                        data[`fiNqName${val.fdisDate}`] = val.fiNqName;
                        data[`fdisColor${val.fdisDate}`] = val.fiNqCourseSignColor
                        data[`fdisId${val.fdisDate}`] = val.fdisId
                    })
                    this.sourceData.push(data)
                })
                this.tableData = this.sourceData;
                this.loadings.close();


            });
        },
    },
};
</script>

<style>
.table-header-cell-class2 {
    background: #FF99CC !important;
    color: #fff !important;
}

.el-popover {
    white-space: pre-wrap !important
}

.custom-name-filter {
    padding: 10px;
}

.custom-name-filter .custom-name-filter-operation .name-filter-cancel,
.name-filter-confirm {
    &:hover {
        color: #1890ff;
    }
}

.custom-name-filter .custom-name-filter-operation .name-filter-cancel {
    float: left;
}

.custom-name-filter .custom-name-filter-operation .name-filter-confirm {
    float: right;
}

.custom-name-filter .custom-name-filter-operation {
    cursor: pointer;
    margin: 10px 10px 0px 0;
}

.table-header-cell-class {
    /* background: var(--bg-color) !important; */
    /* color: var(--font-color) !important; */
    border-right: 0px !important;
    padding: 0 !important;
    margin: 0 !important;
    height: 24px !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content thead.ve-table-header tr.ve-table-header-tr {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
    padding: 0 !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
    padding: 0 !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr {
    height: auto !important;
    padding: 0 !important;
    margin: 0 !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>